import { getErrorsWhitelist } from 'services/client/repositories/downloads';

export const fetchErrorWhitelist = async (): Promise<string[]> => {
  const { errorWhitelist } = await getErrorsWhitelist();

  // eslint-disable-next-line no-console
  console.log(
    `Downloaded latest Error whitelist w/ ${errorWhitelist.length} entries`,
  );

  return errorWhitelist;
};
